// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lCQb","col":"styles_col__267ky"};